import { Link } from 'react-router-dom'
import { CircleQuestionMark, Phone } from 'lucide-react'

const QuickLinks = () => (
  <nav
    aria-label="Quick links"
    className="bg-card border-border/60 overflow-hidden rounded-xl border shadow-sm"
  >
    <div className="bg-foreground px-5 py-3">
      <h2 className="text-sm font-bold tracking-wider text-white uppercase">
        Quick links
      </h2>
    </div>
    <ul className="space-y-2 p-5 sm:p-6">
      <li>
        <Link
          to="/faqs"
          className="text-foreground flex items-center gap-2 py-1 text-base font-semibold hover:text-[#FF914D]"
        >
          <CircleQuestionMark
            className="h-5 w-5 shrink-0 text-[#FF914D]"
            aria-hidden="true"
          />
          FAQs
        </Link>
      </li>
      <li>
        <Link
          to="/contact"
          className="text-foreground flex items-center gap-2 py-1 text-base font-semibold hover:text-[#FF914D]"
        >
          <Phone
            className="h-5 w-5 shrink-0 text-[#FF914D]"
            aria-hidden="true"
          />
          Contact us
        </Link>
      </li>
    </ul>
  </nav>
)

export default QuickLinks
